"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Marker = void 0;
const leaflet_1 = __importDefault(require("leaflet"));
const react_1 = __importStar(require("react"));
const client_1 = __importDefault(require("react-dom/client"));
const ObjectInMap_1 = require("./ObjectInMap");
const MarkerContainer = ({ marker, map, element }) => {
    const [visible, setVisible] = react_1.default.useState(marker.isActive);
    const onClick = (e) => {
        e.stopPropagation();
        marker.callEventCallback("click", e);
    };
    const onMouseOver = (e) => {
        e.stopPropagation();
        marker.callEventCallback("mouseover", e);
    };
    const onMouseLeave = (e) => {
        e.stopPropagation();
        marker.callEventCallback("mouseout", e);
    };
    (0, react_1.useEffect)(() => {
        marker.addListener("activechange", () => {
            setVisible(marker.isActive);
        }, true);
    }, []);
    return (react_1.default.createElement("div", { style: {
            position: "absolute",
            display: visible ? "block" : "none"
        }, onClick: onClick, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave }, element(marker, map)));
};
class Marker extends ObjectInMap_1.ObjectInMap {
    constructor(latitude, longitude, marker, map, name = "Marker", options) {
        super(map, name, options);
        this.isActive = false;
        this.reactElement = marker;
        const html = "<div></div>";
        const size = 0;
        const icon = leaflet_1.default.divIcon({
            className: "marker-div",
            html,
            iconSize: [size, size],
            iconAnchor: [0, 0]
        });
        this.location = [latitude, longitude];
        this.marker = leaflet_1.default.marker([latitude, longitude], { icon });
        this.marker.on("add", (e) => {
            if (!this.map) {
                console.error("Cannot continue in add callback - Map not attached to marker");
                return;
            }
            const htmlElement = e.target._icon;
            this.htmlElement = htmlElement;
            const htmlRoot = client_1.default.createRoot(htmlElement);
            htmlRoot.render(react_1.default.createElement(MarkerContainer, { marker: this, map: this.map, element: this.reactElement }));
            // Disable click propagation to leaflet map
            leaflet_1.default.DomEvent.disableClickPropagation(this.htmlElement);
        });
        this.setActive(true);
    }
    setLocation(location) {
        super.setLocation(location);
        this.marker.setLatLng(this.location);
    }
    getLeafletMarker() {
        return this.marker;
    }
    addToLayer(layer) {
        super.setParent(layer);
    }
    initialize() {
        const added = super.initialize();
        this.marker.addTo(this.map);
        return this;
    }
    delete() {
        super.delete();
        this.marker.remove();
    }
}
exports.Marker = Marker;
